import { FloatingLabel, Form } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { isEmpty } from 'lodash';
import Cards from './cards';
import { CartFilterTypes } from './prop_types';

const CardsFilter = ({
  filters,
  cards,
  fetchStatus = 'succeed',
  emptyState = '',
  cardAttrs = {},
  cardsFilterTitle = '',
  filterPosition = 'center',
  pagination = null,
  moreLink = null,
}) => (
  <div>
    {filterPosition === 'right' && (
      <div className="row">
        <div className="col mb-5">
          <h2>{cardsFilterTitle}</h2>
        </div>

        {filters.map(({ title, options, onChange, initialValue = '' }) => (
          <div className="col-sm-12 col-md-6 col-lg-4 mb-5">
            <div className="d-flex flex-column flex-md-row align-items-md-center">
              <div className="fw-bold text-nowrap mb-1 mb-md-0">{title}</div>

              <Form.Select
                aria-label="Select events by month"
                className="ms-md-4"
                value={initialValue}
                onChange={(e) => onChange({ value: e.target.value })}
              >
                {options.map(({ value, label, key, disabled = null }) => (
                  <option value={value} key={key || value} disabled={disabled}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
        ))}
      </div>
    )}

    {filterPosition === 'center' && (
      <div className="row justify-content-center mb-5">
        {filters.map(({ title, options, onChange, initialValue = '' }) => (
          <div className="col col-md-4 col-lg-3" key={title}>
            <FloatingLabel controlId={title} label={title}>
              <Form.Select
                aria-label={title}
                value={initialValue}
                onChange={(e) => onChange({ value: e.target.value, title })}
              >
                {options.map(({ value, label, key }) => (
                  <option value={value} key={key || value}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </div>
        ))}
      </div>
    )}

    <Cards
      cards={cards}
      fetchStatus={fetchStatus}
      emptyState={emptyState}
      cardAttrs={cardAttrs}
    />

    {!isEmpty(pagination) && (
      <ReactPaginate
        className="pagination justify-content-center mt-5"
        nextLabel={<i className="fa-solid fa-angle-right" />}
        onPageChange={({ selected }) => pagination.onChange(selected + 1)}
        forcePage={pagination.page - 1}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={Math.ceil(pagination.total / pagination.perPage)}
        previousLabel={<i className="fa-solid fa-angle-left" />}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    )}

    {!isEmpty(moreLink) && moreLink}
  </div>
);

export default CardsFilter;

CardsFilter.propTypes = CartFilterTypes;
